export default {
  "content": "<path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"4.7\" d=\"M44.077 44.733l22.318 22.321\"/><path stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"4.7\" d=\"M51.452 27.087c0 13.393-10.861 24.254-24.255 24.254-13.394 0-24.255-10.86-24.255-24.254 0-13.394 10.861-24.255 24.255-24.255 13.394 0 24.255 10.86 24.255 24.255z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 69 70",
    "width": "69",
    "height": "70",
    "fill": "none"
  }
};